export enum InventoryHoldArea {
  InboundHold = "I/H",
  OutboundHold = "O/H",
  Warehouse = "WHS",
  OffSpecArea = "O/S",
}

export const HOLD_AREA_TO_LABEL: Record<InventoryHoldArea, string> = {
  [InventoryHoldArea.InboundHold]: "Inbound Hold",
  [InventoryHoldArea.OutboundHold]: "Outbound Hold",
  [InventoryHoldArea.Warehouse]: "Warehouse",
  [InventoryHoldArea.OffSpecArea]: "Off Spec Area",
}

export const LOT_LOCKED_TOOLTIP =
  "This lot is locked due to a pending adjustment, work order, lot selection, or open goods receipt."

export const PALLET_LOCKED_TOOLTIP =
  "This pallet is locked due to a pending adjustment, work order, lot selection, or open goods receipt."

export const ALL_LOTS_LOCKED_TOOLTIP =
  "All lots on this pallet are locked due to a pending adjustment, work order, lot selection, or open goods receipt."

export const PALLET_SEARCH_PLACEHOLDER = "Search by Reference #, Lot # or Batch #"

export const PALLET_COLUMN_COUNT_WITHOUT_QOH = 2
export const PALLET_COLUMN_COUNT = PALLET_COLUMN_COUNT_WITHOUT_QOH + 1
export const LOT_COLUMN_COUNT = 7
export const PALLET_TOGGLE_COLUMN_COUNT = 1
export const LOT_TOGGLE_COLUMN_COUNT = 1

export const OFF_SPEC_AREA_ELIGIBLE_EXTERNAL_SYSTEM_IDS: readonly string[] = ["00", "01", "02", "40", "42", "61", "90"]

export const SHELVING_DEFAULT_FORM_VALUES = {
  binSize: null,
  aisleCode: null,
  sectionCode: null,
  binNumber: null,
  warehouseShelvingId: null,
} as const

export const DESTINATION_DEFAULT_FORM_VALUES = {
  holdArea: InventoryHoldArea.Warehouse,
  shelving: SHELVING_DEFAULT_FORM_VALUES,
} as const

export const WORK_ORDER_PRINT_PAGE_STYLE = `
  @page {
    size: landscape;
    margin: 10mm;
  }

  @media print {
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
`
